import { connect } from 'react-redux'
import { push } from 'react-router-redux'
import { authenticate } from '../../actions/auth'
import Login from '../../components/login/login'

const mapStateToProps = (state) => ({
  initialValues: {
    remember: true
  }
})

const mapDispatchToProps = (dispatch, newProps) => ({
  onSubmit (data) {
    return dispatch(authenticate(data))
      .then((action) => { 
        if ( action.meta.status === 401 ) return Promise.reject({_error: 'Invalid username or password'})
        if ( action.meta.status >= 400 && action.meta.status <= 599  ) return Promise.reject({_error: action.meta.statusText})
      })
  }
})

export default connect(mapStateToProps, mapDispatchToProps)(Login)



// WEBPACK FOOTER //
// ./src/containers/login/login-container.js